/** Maximum length for manual (handwritten) meeting memo text; aligned with BFF/backend validation. */
export const MAX_MEETING_MANUAL_MEMO_LENGTH = 1000;
